import React from 'react'

export const statsContent = {
  didYouKnow: 'Did you know...',
  firstStat: (
    <p>
      Since we launched in 2017, our money back customers have had over{' '}
      <strong>£3,700,000</strong> back on their unused data.
    </p>
  ),
  secondStat: 'Most people in the UK don’t use all their data each month.',
  thirdStat:
    'On average, customers on our data discount plans only use 34% of their data each month.',
}
